import apiInstance from "../axiosConfig";
import { DB_ENDPOINTS } from "../endpoints";
export const trackCitrusImpression = (networkBrand, adId) => apiInstance.get(DB_ENDPOINTS.CITRUS_IMPRESSION(networkBrand, adId));
export const trackCitrusClick = (networkBrand, adId) => apiInstance.get(DB_ENDPOINTS.CITRUS_CLICK(networkBrand, adId));
